import "./Newsroom.module.css";
import Navigation from "@/reusable_sections/Header";
import Stories from "./sections/Stories";
import Categories from "./sections/Categories";
import Footer from "@/reusable_sections/Footer";
export default function NewsroomPage() {
  return <div>
      <Navigation />
      <Stories />
      <Categories />
      <Footer />
    </div>;
}